import React from "react";
import { MUIBox, tokens, MUICircularProgress } from "@cobee/cobee-ui";

export default function CobeeLoader() {
  return (
    <MUIBox
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MUICircularProgress sx={{ color: tokens.palette.secondary.main }} />
    </MUIBox>
  );
}
